import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { EmailTemplatesAssignedOffersEffects } from './auto-reply/assigned-offers/assigned-offers.effects';
import {
  EmailTemplatesAssignedOffersNamespace,
  EmailTemplatesAssignedOffersReducer,
} from './auto-reply/assigned-offers/assigned-offers.store';
import { EmailTemplatesAutoReplyCollectionEffects } from './auto-reply/collection/auto-reply-collection.effects';
import {
  EmailTemplatesAutoReplyCollectionNamespace,
  EmailTemplatesAutoReplyCollectionReducer,
} from './auto-reply/collection/auto-reply-collection.store';
import { EmailTemplatesAutoReplyItemEffects } from './auto-reply/item/auto-reply-item.effects';
import {
  EmailTemplatesAutoReplyItemNamespace,
  EmailTemplatesAutoReplyItemReducer,
} from './auto-reply/item/auto-reply-item.store';
import { EmailTemplatesEventInvitationEffects } from './event-invitation/event-invitation.effects';
import {
  EmailTemplatesEventInvitationNamespace,
  EmailTemplatesEventInvitationReducer,
} from './event-invitation/event-invitation.store';
import { EmailTemplatesGeneralEffects } from './general/general.effects';
import {
  EmailTemplatesGeneralNamespace,
  EmailTemplatesGeneralReducer,
} from './general/general.store';

@NgModule({
  imports: [
    StoreModule.forFeature(EmailTemplatesGeneralNamespace, EmailTemplatesGeneralReducer),
    StoreModule.forFeature(
      EmailTemplatesEventInvitationNamespace,
      EmailTemplatesEventInvitationReducer,
    ),
    StoreModule.forFeature(
      EmailTemplatesAutoReplyCollectionNamespace,
      EmailTemplatesAutoReplyCollectionReducer,
    ),
    StoreModule.forFeature(
      EmailTemplatesAutoReplyItemNamespace,
      EmailTemplatesAutoReplyItemReducer,
    ),
    StoreModule.forFeature(
      EmailTemplatesAssignedOffersNamespace,
      EmailTemplatesAssignedOffersReducer,
    ),
    EffectsModule.forFeature([
      EmailTemplatesGeneralEffects,
      EmailTemplatesEventInvitationEffects,
      EmailTemplatesAutoReplyCollectionEffects,
      EmailTemplatesAutoReplyItemEffects,
      EmailTemplatesAssignedOffersEffects,
    ]),
  ],
})
export class EmailTemplatesDataModule {}
